import React from 'react';
import SEO from '../SEO';
import { useLanguage } from '../../i18n';

const PrivacyPolicy = () => {
  const { t } = useLanguage();

  return (
    <div className="privacy-container">

      <SEO
        title={t("seo.privacyTitle")}
        description={t("seo.privacyDescription")}
        url="https://fixanor.com/privacy-policy"
        image="https://fixanor.com/images/hero-image-webp.webp"
      />
      <style>{`
        .privacy-container {
          max-width: 800px;
          margin: 0 auto;
          padding: 40px 20px;
          font-family: inherit;
          color: var(--color-text);
          line-height: 1.6;
          background-color: var(--color-bg);
        }

        .privacy-container h1 {
          font-size: 36px;
          margin-bottom: 10px;
          text-align: center;
        }

        .privacy-container .updated {
          font-size: 14px;
          text-align: center;
          color: var(--color-subtle);
          margin-bottom: 30px;
        }

        .privacy-container section {
          margin-bottom: 40px;
        }

        .privacy-container h2 {
          font-size: 22px;
          margin-bottom: 10px;
          color: var(--color-heading);
          text-align: left;
        }

        .privacy-container p {
          text-align: left;
          margin-bottom: 10px;
        }

        .privacy-container ul {
          list-style: disc;
          margin-left: 20px;
          padding-left: 0;
          text-align: left;
        }

        .privacy-container li {
          margin-bottom: 8px;
        }

        .privacy-container a {
          color: var(--color-link);
          text-decoration: none;
        }

        .privacy-container a:hover {
          text-decoration: underline;
        }

        .privacy-container code {
          background-color: var(--color-surface-muted);
          color: var(--color-text);
          padding: 2px 4px;
          border-radius: 4px;
          font-family: monospace;
        }
      `}</style>

      <h1>{t("privacy.heading")}</h1>
      <p className="updated">{t("privacy.updated")}</p>

      <section>
        <h2>{t("privacy.whoTitle")}</h2>
        <p>
          {t("privacy.whoText")}<br />
          <strong>{t("common.email")}:</strong> contact@fixanor.com<br />
          <strong>{t("common.phone")}:</strong> +40 774 924 548
        </p>
      </section>

      <section>
        <h2>{t("privacy.dataTitle")}</h2>
        <ul>
          {t("privacy.dataItems").map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </section>

      <section>
        <h2>{t("privacy.useTitle")}</h2>
        <p>{t("privacy.useIntro")}</p>
        <ul>
          {t("privacy.useItems").map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </section>

      <section>
        <h2>{t("privacy.storageTitle")}</h2>
        <p>
          {t("privacy.storageText1")}
        </p>
        <p>
          {t("privacy.storageText2")}
        </p>
      </section>

      <section>
        <h2>{t("privacy.cookiesTitle")}</h2>
        <p>
          {t("privacy.cookiesText")}
        </p>
      </section>

      <section>
        <h2>{t("privacy.rightsTitle")}</h2>
        <p>{t("privacy.rightsIntro")}</p>
        <ul>
          {t("privacy.rightsItems").map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
        <p>{t("privacy.rightsContact")}</p>
      </section>

      <section>
        <h2>{t("privacy.legalTitle")}</h2>
        <p>{t("privacy.legalText")}</p>
      </section>

      <section>
        <h2>{t("privacy.retentionTitle")}</h2>
        <p>
          {t("privacy.retentionText")}
        </p>
      </section>

      <section>
        <h2>{t("privacy.thirdPartyTitle")}</h2>
        <p>{t("privacy.thirdPartyIntro")}</p>
        <ul>
          <li><a href="https://www.brevo.com" target="_blank" rel="noopener noreferrer">{t("privacy.brevo")}</a></li>
          <li><a href="https://www.zoho.com/mail/" target="_blank" rel="noopener noreferrer">{t("privacy.zoho")}</a></li>
          <li>
            <a href="https://www.cloudflare.com/privacypolicy/" target="_blank" rel="noopener noreferrer">
              {t("privacy.cloudflare")}
            </a>
          </li>
        </ul>
      </section>

      <section>
        <h2>{t("privacy.changesTitle")}</h2>
        <p>{t("privacy.changesText")}</p>
      </section>

      <section>
        <h2>{t("privacy.contactTitle")}</h2>
        <p>
          <strong>Fixanor Software Solutions S.R.L.</strong><br />
          {t("privacy.address")}<br />
          {t("common.email")}: contact@fixanor.com<br />
          {t("common.phone")}: +40 774 924 548
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
